module.exports = __webpack_public_path__ + "img/disConnected.3df6fbde.svg";